import {useEffect, useState} from 'react';
import {
  createSelectionOptionsUtil,
  DefaultPaginationValues,
  queryString,
} from '../../../Util/commonUtility.js';
import {useDispatch, useSelector} from 'react-redux';
import {setPageNumber, setPageSize} from '../../../Store/Actions/pageSize';
import {
  getAllEmailSchedulers,
  deleteEventTemplateSchedulerById,
  setEventTemplateEdit,
  getAllChaptersByQueryStringForSearch,
} from '../../../Store/Actions';
import AllEmailSchedulerComponent from '../../../Components/AdminComponents/AllEmailScheduler';
import {getAllEventsByQueryStringSearch} from '../../../Store/Actions/events.js';
const AllEmailSchedulerContainer = () => {
  const dispatch = useDispatch();
  const {allEmailSchedulers} =
    useSelector(({eventTemplateSchedulers}) => eventTemplateSchedulers) || {};
  const [listData, setListData] = useState();
  const memorizedPageNumber = useSelector(
    ({pageSizes}) => pageSizes.pageNumbers.eventTemplateSchedulers,
  );
  const [eventsList, setEventsList] = useState([]);
  const [chaptersList, setChaptersList] = useState([]);
  const [fetching, setFetching] = useState(false);

  const {allEventsQueryData} = useSelector(({events}) => events);
  const {allChaptersQueryData} = useSelector(({chapters}) => chapters);

  const memorizedPageSize = useSelector(
    ({pageSizes}) => pageSizes.pageSizes.eventTemplateSchedulers,
  );
  const [pagination, setPagination] = useState({
    page: memorizedPageNumber || DefaultPaginationValues.PAGE,
    pageCount: memorizedPageSize || DefaultPaginationValues.PAGE_SIZE,
    totalPages: DefaultPaginationValues.TOTAL_PAGES,
  });
  const [sortParams, setSortParams] = useState({
    field: 'schedule_date',
    order: 'ascend',
  });
  const [paginationAndSortChanged, setPaginationAndSortChanged] =
    useState(false);
  const searchValues = useSelector(
    ({dynamicSearch}) => dynamicSearch.searchValues.eventEmailSchedulers,
  );

  useEffect(() => {
    if (allEmailSchedulers) {
      setListData(allEmailSchedulers?.data?.eventEmailTemplates);
      setPagination({
        ...pagination,
        page: allEmailSchedulers?.data?.currentPage,
        totalPages: allEmailSchedulers?.data?.totalPage,
        totalCount: allEmailSchedulers?.data?.totalCount,
      });
    } else {
      // Reducer clears allEmailSchedulers on delete/update/etc.; refetch must keep filters.
      fetchEventEmailScheduler(searchValues);
    }
  }, [allEmailSchedulers?.data?.eventEmailTemplates]);

  useEffect(() => {
    if (paginationAndSortChanged) {
      fetchEventEmailScheduler(searchValues);
      setPaginationAndSortChanged(false);
    }
  }, [paginationAndSortChanged, searchValues]);

  useEffect(() => {
    if (searchValues) {
      dispatch(setPageNumber('eventSchedulerTemplate', 1));
      setPagination({
        ...pagination,
        page: 1,
      });
      setPaginationAndSortChanged(true);
    }
  }, [searchValues]);

  const handleTableChange = (pagination, filter, sorter) => {
    setSortParams({
      field: sorter.field,
      order: sorter.order,
    });
    setPaginationAndSortChanged(true);
  };
  const handlePaginationChange = (current, pageSize) => {
    dispatch(setPageSize('eventSchedulerTemplate', pageSize));
    dispatch(setPageNumber('eventSchedulerTemplate', current));

    setPagination({
      ...pagination,
      page: current,
      pageCount: pageSize,
    });
    setPaginationAndSortChanged(true);
  };
  const fetchEventEmailScheduler = async (searchValues) => {
    const sortField = sortParams.field || '';
    const sortOrder = sortParams.order || '';
    const searchQueryData = queryString(searchValues);
    dispatch(
      getAllEmailSchedulers(sortField, sortOrder, searchQueryData, pagination),
    );
  };

  const deleteEventEmailScheduler = async (id) => {
    dispatch(deleteEventTemplateSchedulerById(id));
  };
  const handleEditTemplate = (editTemplateState) => {
    dispatch(setEventTemplateEdit(editTemplateState));
  };

  useEffect(() => {
    if (allEventsQueryData.forSearch) {
      setEventsList(
        createSelectionOptionsUtil(
          allEventsQueryData.forSearch?.data?.events,
          'id',
          'name',
        ),
      );
      setFetching(false);
    } else {
      dispatch(
        getAllEventsByQueryStringSearch('', '', '', {
          page: 1,
          pageCount: 10,
        }),
      );
    }
  }, [allEventsQueryData.forSearch]);

  useEffect(() => {
    const visibleChapters =
      allChaptersQueryData?.forSearch?.data?.chapters?.filter(
        (chapter) => chapter?.is_visible_on_map === true,
      );
    if (allChaptersQueryData?.forSearch) {
      setChaptersList(
        createSelectionOptionsUtil(visibleChapters, 'id', 'name'),
      );
    } else {
      dispatch(
        getAllChaptersByQueryStringForSearch('', '', '', {
          page: 1,
          pageCount: 100,
        }),
      );
    }
  }, [allChaptersQueryData?.forSearch]);

  return (
    <div>
      <AllEmailSchedulerComponent
        allEventEmails={listData}
        paging={pagination}
        handlePaginationChange={(page, pageSize) =>
          handlePaginationChange(page, pageSize)
        }
        deleteEventEmail={(id) => deleteEventEmailScheduler(id)}
        handleEditTemplate={(editTemplateState) =>
          handleEditTemplate(editTemplateState)
        }
        handleTableChange={handleTableChange}
        fetchEventEmails={(searchValues) =>
          fetchEventEmailScheduler(searchValues)
        }
        sortParams={sortParams}
        searchValues={searchValues}
        eventsList={eventsList}
        setEventsList={setEventsList}
        fetching={fetching}
        setFetching={setFetching}
        chaptersList={chaptersList}
      />
    </div>
  );
};

export default AllEmailSchedulerContainer;
